module.exports = __webpack_public_path__ + "img/clienti-applepay.712eb63d.jpg";